import { render, staticRenderFns } from "./TableSizeEditor.vue?vue&type=template&id=72e05ff5&scoped=true&"
import script from "./TableSizeEditor.vue?vue&type=script&lang=ts&"
export * from "./TableSizeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TableSizeEditor.vue?vue&type=style&index=0&id=72e05ff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e05ff5",
  null
  
)

export default component.exports